import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { TetherIconColorOptions } from '@/components/CurrencySymbolMask/CurrencyIcon';
import { formatCurrency } from '@/pages/table/utils/utils';

const getStackAmountColor = (playerIsAllIn: boolean) => {
  return playerIsAllIn ? 'text-ph-orange' : 'text-white';
};

interface CurrencyDisplayProps {
  stack: number;
  getCurrencyColor: () => TetherIconColorOptions | undefined;
  CurrencyIcon: React.ElementType;
  isCappedGame: boolean;
  playerIsAllIn: boolean;
  joining: boolean;
  shouldDisplayInBB: boolean;
  bigBlind: number;
  totalStack?: number;
  shortFormat?: boolean;
  mobileFormat?: boolean;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  stack,
  getCurrencyColor,
  CurrencyIcon,
  isCappedGame,
  playerIsAllIn,
  joining,
  shouldDisplayInBB,
  bigBlind,
  totalStack,
  shortFormat = false,
  mobileFormat = false,
}) => {
  const isDisplayingBB = shouldDisplayInBB && bigBlind;
  const displayValue = isDisplayingBB
    ? `${formatCurrency(stack / bigBlind)} BB`
    : formatCurrency(stack, { shortFormat, mobileFormat });
  const totalStackDisplay =
    isDisplayingBB && totalStack
      ? `${formatCurrency(totalStack / bigBlind)} BB`
      : formatCurrency(totalStack, { shortFormat, mobileFormat });

  if (joining) {
    return (
      <span className="h-auto">
        <LoadingSpinner size="3" fullWidth={false} className="mx-auto" />
      </span>
    );
  }

  return (
    <div className={twMerge('text-base font-semibold', getStackAmountColor(playerIsAllIn))}>
      {isCappedGame ? (
        <div className="flex flex-col items-center justify-center font-bold">
          <div className="flex items-center justify-center">
            {!isDisplayingBB && (
              <div className="py-0.5">
                <CurrencyIcon fill={getCurrencyColor()} />{' '}
              </div>
            )}
            <span className="leading-3 text-ph-white"> {displayValue}</span>
          </div>
          <span className={twMerge('text-ph-white-50', !isDisplayingBB && 'leading-3')}>({totalStackDisplay})</span>
        </div>
      ) : (
        <div className="flex">
          {!isDisplayingBB && <CurrencyIcon size={16} fill={getCurrencyColor()} />}
          <span>{displayValue}</span>
        </div>
      )}
    </div>
  );
};

export default CurrencyDisplay;
